















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Document } from '@/model/document2/document';
import { InsertionData, ColumnData } from '@/model/document2/insertionData/insertionData';

import * as def from "@/definitions";

import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";

@Component({
  components: {
    DropdownList,
    ArrowDown,
    ArrowRight
  }
})
export default class TableRowStyle extends Vue {

    @Prop() private document!: Document;

    //-----開閉のアニメーション-----//
    openStatus = {
        opend: true
    };

    tableRowStyleContentsOpenAnimate = false;
    tableRowStyleContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
            this.tableRowStyleContentsCloseAnimate = true;
            setTimeout(() => {
                this.tableRowStyleContentsCloseAnimate = false;
                this.tableRowStyleContentsOpenAnimate = false;
                this.openStatus.opend = false;
            }, 200);
        } else {
            this.openStatus.opend = true;
            this.tableRowStyleContentsOpenAnimate = true;
            setTimeout(() => {
                this.tableRowStyleContentsOpenAnimate = false;
            }, 250);
        }
    }
    //-----開閉のアニメーション-----//

    private getSelectedColumnData()
    {
        var data = this.document.insertionData.getColumnData(this.document.selectedInsertionColumn);
        return data;
    }

    //-----語頭語尾-----//
    get prefix()
    {
        return this.getSelectedColumnData().prefix;
    }

    get suffix()
    {
        return this.getSelectedColumnData().suffix;
    }

    onSetPrefix(value)
    {
        this.changeColumnDataProperty(value , "prefix")
    }

    onSetSuffix(value)
    {
        this.changeColumnDataProperty(value , "suffix")
    }

    private changeColumnDataProperty(value : any, propertyName : string)
    {
        this.$emit("doCommand", "changeColumnDataProperty", { value : value, propertyName : propertyName });
    }

    //--color--//
    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style; 
    }
}
